<template>
    <Modal @shown="shown" @hidden="hidden" ref="modal" @submit="submit">
        <template #title>
            {{ i18n('Clone profiles') }}
        </template>
        <div class="alert alert-danger mb-2" v-if="errorMessage">{{ errorMessage }}</div>

        <div class="row" v-if="!user">
            <div class="col mb-2">
                <Field :disabled="submitted" type="dictionary" rest="users" :required="true" :customAutofocus="true"
                    :label="i18n('Target user')" v-model="formData.target_user_id" :errorMessage="errorMessages.user_id"
                    name="target_user_id" :sort="(a, b) => { return a.name.localeCompare(b.name); }" />
            </div>
        </div>
        <div class="row" v-if="user">
            <div class="col mb-2">
                <Field :disabled="true" type="dictionary" rest="users" :required="true" :customAutofocus="true"
                    :label="i18n('Target user')" v-model="formData.target_user_id" :errorMessage="errorMessages.user_id"
                    :value="user.id" name="target_user_id" :sort="(a, b) => { return a.name.localeCompare(b.name); }" />
            </div>
        </div>
        <div class="row">
            <div class="col mb-2">
                <Field :disabled="submitted" type="dictionary" rest="users" :required="true" :customAutofocus="true"
                    :label="i18n('Source user')" v-model="formData.user_id" :errorMessage="errorMessages.user_id"
                    name="source_user_id" :sort="(a, b) => { return a.name.localeCompare(b.name); }" />
            </div>
        </div>

        <template #footer>
            <div class="row">
                <div class="col text-end">
                    <button type="submit" class="btn btn-dark btn-sm" :disabled="submitted">
                        {{ i18n('Save') }}
                    </button>
                </div>
            </div>
        </template>
    </Modal>
</template>
<script>
import api from "@/api.js";
import Modal from "@/components/common/layout/Modal.vue";
import Field from "@/components/common/form/Field.vue";
import { translatedErrorMessage, } from "@/tools/errorHandling.js";

export default {
    components: {
        Modal,
        Field,
    },
    data() {
        return {
            submitted: false,
            formData: {},
            errorMessages: {},
            errorMessage: '',
            is_expiring: false,
            applicationUsernameLoaded: false,
            hasApplicationUsername: false,
        };
    },
    props: {
        user: {
            type: Object,
        },
        application: {
            type: Object,
        },
    },
    emits: [
        'shown',
        'hidden',
        'submit',
        'created',
    ],
    mounted() {
        this.setFormData();
    },
    watch: {
        'formData.application_id': function () {
            this.loadApplicationUsername();
        },
        'formData.user_id': function () {
            this.loadApplicationUsername();
        },
    },
    methods: {
        loadApplicationUsername() {
            this.applicationUsernameLoaded = false;

            if (!this.formData.application_id || !this.formData.user_id
                || !this.$root.features?.profiles?.application_username
            ) {
                this.applicationUsernameLoaded = true;
                return;
            }

            api.get(`users/${this.formData.user_id}/applications/${this.formData.application_id}/username`).then((applicationUsername) => {
                this.formData.username = applicationUsername.username;
                this.hasApplicationUsername = applicationUsername.active;
                this.applicationUsernameLoaded = true;
            });
        },
        setFormData() {
            this.formData = {};
        },
        show() {
            this.submitted = false;
            this.setFormData();
            this.formData.expires_at = null;
            this.is_expiring = false;
            this.errorMessage = '';
            this.applicationUsernameLoaded = false;
            this.hasApplicationUsername = false;

            if (this.user) {
                this.formData.target_user_id = this.user.id;
            } else {
                this.formData.user_id = null;
            }

            this.$refs['modal'].show();
        },
        hide() {
            this.$refs['modal'].hide();
        },
        shown() {
            this.$emit('shown');
        },
        hidden() {
            this.$emit('hidden');
        },
        submit() {
            if (!this.formData.user_id) return;

            let promise;
            this.errorMessage = '';
            this.submitted = true;

            promise = api.post('users/' + this.formData.target_user_id + '/profiles/clone/', {
                source_user_id: this.formData.user_id,
            });

            promise.then(async (profile) => {
                this.$emit('submit', profile);
                this.hide();
                api.clearCache();
            }).catch((errorMessage) => {
                this.errorMessage = translatedErrorMessage(errorMessage);
                this.submitted = false;
            });
        },
    }
};
</script>